import axios from '../utils/axios';

export default function updatePaymentSyncRecord(adminId, data) {
    return axios.post(`/admin/${adminId}/update-payment-sync-record`, data);
}
